/**
 * 获取uuid
 */
export function getUUID () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth (key) {
  return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate (data, id = 'id', pid = 'parentId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      temp[data[k][pid]]['children'].push(data[k])
    } else {
      res.push(data[k])
    }
  }
  return res
}

export function unitChange (price) {
  let priceStr = price + ''
  let length = priceStr.split('.')[0].length
  if (length < 5) {
    return [price, '']
  } else if (length < 10) {
    return [(price / 10000).toFixed(1), '万']
  } else {
    return [(price / 100000000).toFixed(1), '亿']
  }
}

// 获取当前月份的最后一天
export function getMonthLastDay (timestamp) {
  let date = new Date(timestamp)
  let year = date.getFullYear()
  let month = date.getMonth() + 2
  let day = date.getDate()
  return +new Date(year + '-' + month + '-' + day) - 1
}

/**
 * 时间戳时间转字符串格式
 * @params {*} val
 * @params {date, time, datetime} type
 * */
export function formatTime (val, type) {
  if (!val) {
    return '--'
  } else {
    let time = new Date(val)
    let year = time.getFullYear()
    let month = time.getMonth() + 1 + ''
    let day = time.getDate() + ''
    let hour = time.getHours() + ''
    let minute = time.getMinutes() + ''
    let second = time.getSeconds() + ''
    month = month.length === 1 ? '0' + month : month
    day = day.length === 1 ? '0' + day : day
    hour = hour.length === 1 ? '0' + hour : hour
    minute = minute.length === 1 ? '0' + minute : minute
    second = second.length === 1 ? '0' + second : second
    if (type === 'date') {
      return '' + year + '-' + month + '-' + day
    } else if (type === 'time') {
      return '' + hour + ':' + minute + ':' + second
    } else if (type === 'hour') {
      return '' + hour + ':' + minute
    } else {
      return '' + year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
    }
  }
}
export function copy2Clipboard (txt) {
  if (window.clipboardData) {
    window.clipboardData.clearData()
    window.clipboardData.setData('Text', txt)
  } else if (navigator.userAgent.indexOf('Opera') != -1) {
    window.location = txt
  } else if (window.netscape) {
    try {
      netscape.security.PrivilegeManager.enablePrivilege('UniversalXPConnect')
    } catch (e) {
      alert('您使用的浏览器不支持此复制功能，请使用Ctrl+C或鼠标右键。')
      return false
    }
    var clip = Components.classes['@mozilla.org/widget/clipboard;1'].createInstance(Components.interfaces.nsIClipboard)
    if (!clip) return
    var trans = Components.classes['@mozilla.org/widget/transferable;1'].createInstance(Components.interfaces.nsITransferable)
    if (!trans) return
    trans.addDataFlavor('text/unicode')
    var str = new Object()
    var len = new Object()
    var str = Components.classes['@mozilla.org/supports-string;1'].createInstance(Components.interfaces.nsISupportsString)
    var copytext = txt; str.data = copytext
    trans.setTransferData('text/unicode', str, copytext.length * 2)
    var clipid = Components.interfaces.nsIClipboard
    if (!clip) return false
    clip.setData(trans, null, clipid.kGlobalClipboard)
    return true
  }
}
